export const LogoMark = ({ className = 'w-9 h-9' }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="42" stroke="currentColor" strokeWidth="10" />
    <circle cx="50" cy="50" r="24" stroke="currentColor" strokeWidth="5" strokeDasharray="6 6" />
    <path
      d="M50 8V20M50 80V92M8 50H20M80 50H92M20 20L28 28M72 72L80 80M20 80L28 72M72 28L80 20"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ className = '' }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <LogoMark className="w-9 h-9 text-brand-orange shrink-0" />
    <div className="flex flex-col leading-none font-display">
      <span className="text-lg sm:text-xl font-extrabold uppercase tracking-tight text-brand-text">
        Bulk Used Tires
      </span>
      <span className="text-[9px] sm:text-[11px] font-mono tracking-widest text-brand-amber uppercase">
        .com — Worldwide Shipping
      </span>
    </div>
  </div>
);
